import { createContext, useContext, useState } from "react";

/* Shared Entity Sync — ONE active canonical entity id across the DeFi
   intelligence zone (Nerve Center map ↔ What Changed rows ↔ movement
   distribution markers). Matching is by canonical id (protocol:{slug}),
   never display-name strings. Falls back to local state when unwrapped. */
type Sync = { activeId: string | null; setActiveId: (id: string | null) => void };
const Ctx = createContext<Sync | null>(null);

export const EntitySyncProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeId, setActiveId] = useState<string | null>(null);
  return <Ctx.Provider value={{ activeId, setActiveId }}>{children}</Ctx.Provider>;
};

export const useEntitySync = (): Sync => {
  const shared = useContext(Ctx);
  const [localId, setLocalId] = useState<string | null>(null);
  return shared ?? { activeId: localId, setActiveId: setLocalId };
};
